import { Box, Button, Popover } from "@mui/material";
import React, { useState } from "react";

const tagColors: string[] = [
	"#5eaf60", // light green
	"green", // green
	"#62bd9c", // turquoise green
	"#53a285", // muted green
	"#add8e6", // pastel sky blue
	"#3280ba", // blue
	"blue", // pure blue
	"#5293c5", // light blue
	"#3d556f", // dark slate blue
	"#a362bf", // purple
	"#dab0d8", // lighter violet
	"black", // black
	"#e74b3c", // red orange
	"red", // red
	"#bf3b2c", // dark red
];

interface ColorSwatchProps {
	color: string;
	onSelect: (color: string) => void;
}

const ColorSwatch: React.FC<ColorSwatchProps> = ({ color, onSelect }) => {
	return (
		<Box
			sx={{
				width: "25px",
				height: "25px",
				display: "inline-block",
				margin: "2px",
				borderRadius: "4px",
				cursor: "pointer",
				"&:hover": {
					transform: "scale(1.1)",
					transition: "transform 0.1s ease-in-out",
				},
			}}
			style={{ backgroundColor: color }}
			onClick={() => onSelect(color)}
		/>
	);
};

interface ColorPickerV2Props {
	color: string;
	onColorChange: (newColor: string) => void;
}

export const ColorPickerV2: React.FC<ColorPickerV2Props> = ({
	color,
	onColorChange,
}) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleColorSelect = (newColor: string) => {
		onColorChange(newColor);
		handleClose();
	};

	const open = Boolean(anchorEl);
	const id = open ? "color-picker-popover" : undefined;

	return (
		<div>
			<Button
				aria-describedby={id}
				variant="outlined"
				onClick={handleClick}
				style={{
					backgroundColor: color,
					width: "30px",
					height: "24px",
					minWidth: "30px",
					padding: 0,
					margin: "0 auto",
					border: "1px solid #ccc",
				}}
			/>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						padding: "10px",
						maxWidth: "165px",
					}}
				>
					{tagColors.map((tagColor) => (
						<ColorSwatch
							key={tagColor}
							color={tagColor}
							onSelect={handleColorSelect}
						/>
					))}
				</Box>
			</Popover>
		</div>
	);
};
